// Copyright (c) StrangeBee 2024

import { SessionController, SessionOutput } from 'thehive-sdk';

export interface SessionEventList {
    onList: () => Promise<SessionOutput[] | void>;
    onListUserSessions: (userId: string) => Promise<SessionOutput[] | void>;
    onDelete: (sessionId: string) => Promise<void>;
}

interface SessionEventListParams {
    locale: (label: string) => string;
    controller: SessionController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: SessionEventListParams): SessionEventList => ({
    onList: () => controller.listSessions(),
    onListUserSessions: (userId: string) => controller.listUserSessions(userId),
    onDelete: (sessionId: string) =>
        controller
            .delete(sessionId)
            .then(() => onSuccess?.(true, locale('notification.session.delete')))
            .catch(onError),
});
